import { type RegularAvailabilityById } from "../../model/types";
import isSlotAvailable from "../slots/isSlotAvailable";

export default function hasRegularAvailability(
  regularAvailabilityById: RegularAvailabilityById,
  date: string,
  restaurantId: number,
) {
  const availabilityByDate = regularAvailabilityById[restaurantId];

  if (!availabilityByDate) {
    return false;
  }

  // week view
  if (date === "week") {
    const weekAvailability = Object.values(availabilityByDate).filter(Boolean);
    const hasWeekAvailability = weekAvailability.some(
      (dayAvailability) =>
        dayAvailability &&
        dayAvailability.some((slot) => isSlotAvailable(slot)),
    );

    return hasWeekAvailability;
  }

  // day view
  const dayAvailabilitySlots = availabilityByDate[date];

  if (!dayAvailabilitySlots) {
    return false;
  }

  const hasAvailability = dayAvailabilitySlots.some((slot) =>
    isSlotAvailable(slot),
  );

  return hasAvailability;
}
